import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useCreateOrder } from "@/hooks/use-create-order";
import { useCheckoutForm } from "@/pages/checkout/hooks/use-checkout-form";
import { useCheckoutStoreApi } from "@/pages/checkout/stores/use-checkout-store";
import { isFormValid } from "@/pages/checkout/validation/checkout-validation";
import { buildCreateOrderRequest } from "@/services/orders/orders.mapper";
import { Paths } from "@/common/paths/paths";
import type { IItemVersion } from "@/common/types/item.types";
import { useSession } from "@/providers/session-provider";

export const useSubmitOrder = (selectedVersion: IItemVersion) => {
  const history = useHistory();
  const { username } = useSession();
  const { isDeviceReturnRequired, markSubmitAttempted } = useCheckoutForm();
  const storeApi = useCheckoutStoreApi();
  const { mutate, isPending, error: submitError } = useCreateOrder();

  const submitOrder = useCallback(() => {
    const { form } = storeApi.getState();

    markSubmitAttempted();

    const { isValid } = isFormValid(form, isDeviceReturnRequired);

    if (!isValid) {
      return;
    }

    const request = buildCreateOrderRequest(form, selectedVersion, username ?? "", isDeviceReturnRequired);

    mutate(request, {
      onSuccess: (response) => {
        history.push({
          pathname: Paths.confirmation.url,
          state: { orderReference: response.orderReference, itemType: "hardware" },
        });
      },
    });
  }, [storeApi, markSubmitAttempted, selectedVersion, username, isDeviceReturnRequired, mutate, history]);

  return {
    submitOrder,
    isSubmitting: isPending,
    submitError,
  };
};
